import styled from "styled-components";
import bg from "images/section-bg-licensing.jpg";
import bgMobile from "images/section-bg-licensing-mobile.jpg";

const HelpWithLicenseContainer = styled.div`
  background-image: url(${bg});
  display: flex;
  height: 480px;
  padding: 200px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 71px;

  .license-title {
    color: ${(props) => props.theme.colors.primary.contrast};
    text-align: center;
    font-family: Mulish;
    font-size: 60px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    padding: 0;
  }

  .license-button {
    width: 271px;
  }

  @media screen and (max-width: 1023px) {
    height: 100%;
    background-size: cover;
    display: flex;
    padding: 30px 0px 50px 0px;
    gap: 74px;
    .license-title {
      color: ${(props) => props.theme.colors.primary.contrast};
      text-align: center;
      font-family: Mulish;
      font-size: 35px;
      font-style: normal;
      font-weight: 700;
      line-height: 125%;
      align-self: stretch;
      width: 294px;
    }

    .license-button {
      width: 271px;
      height: 42px;
      color: var(--Light-Primary-Contrast, ${(props) => props.theme.colors.primary.contrast});
      font-feature-settings: "clig" off, "liga" off;
      font-family: Mulish;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: 26px; /* 173.333% */
      letter-spacing: 0.46px;
      text-transform: uppercase;
    }
  }
  @media screen and (max-width: 650px) {
    background-image: url(${bgMobile});
  }
  @media screen and (min-width: 1921px) {
    background-repeat: round;
  }
`;

export default HelpWithLicenseContainer;
